import DealsStrip from "./DealsStrip";
import ValueStrip from "./ValueStrip";
import FeaturedCategories from "./FeaturedCategories";
import BestSellersSection from "./BestSellersSection";
import NewArrivals from "./NewArrivals";

// Merchandising rows, in the order a shopper needs them: where to start
// browsing first, then what other people buy, then the priced offers,
// reassurance, and what is new.
const HomeDetailSection = () => (
  <div className="overflow-hidden">
    <FeaturedCategories />
    <BestSellersSection />
    <DealsStrip />
    <ValueStrip />
    <NewArrivals />
  </div>
);

export default HomeDetailSection;
